
import {Component, Vue} from 'vue-property-decorator'
import {Getter} from "vuex-class";
import {getSmsCodeByRemoveMobile, removeMobile} from "@/api/creatCompany";
import {encryptData} from "@/utils/encryptData";
import TheAuthCode from "@/components/TheAuthCode";

@Component({
  components: { TheAuthCode }
})
export default class Unbind extends Vue {
  @Getter mobile!: string

  userId = ''
  loginName = ''
  smsCode = ''
  businessId = ''
  tel = ''
  toastText = '请先获取验证码'
  seconds = -1 // 倒计时数据

  created() {
    this.userId = this.$route.query.userId as string
    this.loginName = this.$route.query.loginName as string
    this.tel = encodeURIComponent(encryptData(this.mobile))
  }

  sendAuthCode() {
    this.businessId = ''
    getSmsCodeByRemoveMobile({ mobile: this.tel }).then((res) => {
      this.businessId = res.data.businessId
      ;(this.$refs.theAuthCode as any).setTimer()
    }).catch(() => {})
  }

  // 提示语调整
  toastTextChange(seconds:number){
    this.seconds = seconds
    let text = '请先获取验证码'
    if(seconds === -1){
      text = '请先获取验证码'
    }else if(seconds === 0){
      text = '短信验证码已失效，请重新获取'
    }else {
      text = '请输入验证码'
    }
    this.toastText = text
  }

  sureUnbind() {
    if(this.$checkIsEmpty(this.smsCode) || this.seconds===-1) {
      this.$toast(this.toastText)
      return false
    }
    const param = {
      smsCode: this.smsCode,
      mobile: this.tel,
      businessId: this.businessId,
      userId: this.userId
    }

    if(this.smsCode)
    removeMobile(param).then(() => {
      this.$toast.success({
        message: '解除绑定成功',
        duration: 1000,
        onClose: () => {
          window.sessionStorage.setItem('isRefresh', '1')
          this.$router.back()
        }
      })
    }).catch(() => {})
  }

}
